import { Component, ViewContainerRef } from '@angular/core';
import { ApplicationSetting } from '../../models/system-setting/application-setting'
import { ApplicationSettingsService } from '../../services/system-settings/application-setting';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { ToastsManager } from 'ng2-toastr/ng2-toastr';
import { RolePermissionService } from '../../services/role/role-permission.service';

@Component({
  selector: 'app-update-application-settings',
  templateUrl: './update-application-settings.component.html',
  styleUrls: ['./update-application-settings.component.scss']
})
/** update-application-settings component*/
export class UpdateApplicationSettingsComponent {
  /** update-application-settings ctor */
  applicationSettingModel = new ApplicationSetting();
  applicationSettings: ApplicationSetting[];
  applicationSettingId: string;
  public htmlContent: any;
  public shippingPolicy: any;
  public homePageContent: any;
  errorMessage: any;
  configuration = {
    uiColor: '#ffffff',
    toolbarGroups: [{ name: 'clipboard', groups: ['clipboard', 'undo'] },
    { name: 'editing', groups: ['find', 'selection', 'spellchecker'] },
    { name: 'links' }, { name: 'insert' },
    { name: 'document', groups: ['mode', 'document', 'doctools'] },
    { name: 'basicstyles', groups: ['basicstyles', 'cleanup'] },
    { name: 'paragraph', groups: ['list', 'indent', 'blocks', 'align'] },
    { name: 'styles' },
    { name: 'colors' }],
    resize_enabled: false,
    removePlugins: 'save',
    extraPlugins: 'smiley,justify,indentblock,colordialog',
    colorButton_foreStyle: {
      element: 'font',
      attributes: { 'color': '#(color)' }
    },
    height: 188,
    removeDialogTabs: '',
    removeButtons: '',
    format_tags: 'p;h1;h2;h3;pre;div'
  }
  /** edit-faq ctor */
  constructor(private readonly service: ApplicationSettingsService, private readonly activatedRoute: ActivatedRoute,
    private readonly toastr: ToastsManager, private readonly vcr: ViewContainerRef, private readonly router: Router, private readonly rolePermissionService: RolePermissionService) {
    this.rolePermissionService.GetRolePermissions("applicationsetting").subscribe(
      data => {
        if (data != null) {
          var list = data.filter(function (element) {
            return (element.action == "list");
          });
          if (list.length > 0) {
            this.toastr.setRootViewContainerRef(vcr);
            this.getApplicationSettingId();
          }
          else {
            this.router.navigate(["/"]);
          }
        }
        else {
          this.router.navigate(["/"]);
        }
      }
    )
  }
  ngSubmit() {
    
    this.applicationSettingModel.pricacyPolicyText = this.htmlContent;
    this.applicationSettingModel.shippingPolicyText = this.shippingPolicy;
    this.applicationSettingModel.homePageContent = this.homePageContent;
    this.service.UpdateSystemSetting(this.applicationSettingModel);
    this.toastr.success('Application settings has been updated', 'Success');

  }
  getApplicationSetting(id: string) {

    this.service.GetSystemSettingsById(id).subscribe(
      data => {
        this.applicationSettingModel = data;
        setTimeout(() => {
          this.htmlContent = this.applicationSettingModel.pricacyPolicyText;
          this.shippingPolicy = this.applicationSettingModel.shippingPolicyText;
          this.homePageContent = this.applicationSettingModel.homePageContent;
        }, 2000);
        
      }
    )
  }

  getApplicationSettingId() {
    this.service.GetSystemSettings().subscribe(
      data => {
        this.applicationSettings = data;
        for (var i = 0; i < this.applicationSettings.length; i++) {
          this.applicationSettingId = this.applicationSettings[i].id;
        }
        this.getApplicationSetting(this.applicationSettingId);
      }
    );
  }
  
  
}



// WEBPACK FOOTER //
// ./src/app/system-setting-component/update-application-settings/update-application-settings.component.ts